module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/永续经营.cf778309.png";